document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('select').forEach(item => {
    if (item.multiple && item.classList.contains('vw-multiple')) {

      let vwMultiple = new Choices(item, {
        removeItemButton: true,
        itemSelectText: '',
        noChoicesText: '',
        shouldSort: false,
        searchEnabled: false,
        searchChoices: false,
      });

      vwMultiple.passedElement.element.addEventListener(
        'change', function () {
          let input = item.parentNode.querySelector('input.choices__input');
          let dropdownList = item.parentNode.parentNode.querySelector('.choices__list--dropdown');
          let placeholderValue = vwMultiple._placeholderValue;
          let allItemsCount = vwMultiple.config.choices.length;
          let selectedItemsCount = vwMultiple.getValue(true).length;

          if (selectedItemsCount) {
            input.setAttribute('placeholder', '');
            input.classList.add('hidden');

            if (selectedItemsCount === allItemsCount) {
              dropdownList.classList.add('hidden');
            } else {
              dropdownList.classList.remove('hidden');
            }
          } else {
            input.setAttribute('placeholder', placeholderValue);
            input.classList.remove('hidden');
          }

          vwMultiple.hideDropdown();
        },
        false,
      );
    }
  });
}, false);
